import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programsWrapper: {},
  tabsContent: {},
  buttonWeb: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  buttonMobile: {
    display: 'none',
    marginRight: '8px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
}));
